import { render, staticRenderFns } from "./PhoneNumbersMapper.vue?vue&type=template&id=92b3cb48"
import script from "./PhoneNumbersMapper.vue?vue&type=script&lang=ts"
export * from "./PhoneNumbersMapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports